import PositionComponent from '../components/CareersPage/PositionComponent/PositionComponent';
import Make from '../components/MakeSection/Make';

const PositionPage = ({ hideHeaderFooterSetter }) => {
    return (
        <>
            <PositionComponent hideHeaderFooterSetter={hideHeaderFooterSetter} />
            <Make pageKey='PositionPage' />
        </>
    );
};

export default PositionPage;